import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import apiCall from "../../../components/Api";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import MainconternLayout from "../../../components/Layout/MainconternLayout";
import BackBtn from "../../../components/Common/backBtn";
import InputRadioField from "../../../components/Common/inputRadioField";
import InputTextField from "../../../components/Common/inputTextField";
import SucessModal from "../../../components/Modal/SucessModal";
import { ManufacturerBreadcrumbsList } from "../Const";

const MarketersListForm = ({ edit = false }) => {
  const { id } = useParams();

  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useForm();

  const [success, setSuccess] = useState(false);

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}marketers/get/${id}`)
      .then((response) => {
        setValue("marketers_name", response.data.marketers_name);
        setValue("active", response.data.active);
        trigger();
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    edit && getMenuData();
  }, [edit]);

  const onSubmit = async (fields) => {
    if (edit) {
      const result = await apiCall(`marketers/update/${id}`, "PATCH", fields);
      if (result.data?._id) {
        setSuccess(true);
      }
    } else {
      const result = await apiCall(`marketers/create`, "POST", fields);
      if (result.data?._id) {
        setSuccess(true);
      }
    }
  };

  return (
    <>
      <MainconternLayout
        header={
          <>
            <div className="d-flex flex-column pb-2 flex-wrap justify-content-start gap-4">
              <Breadcrumbs
                className="healthsyMasterBreadCrumbs"
                breadcrumbsList={ManufacturerBreadcrumbsList("", edit)}
              />
              <BackBtn navigatePath="/healthsy-services/order-medicines/masters/marketers" />
            </div>
          </>
        }
        footer={<></>}
      >
        <div className="healtharticle-container healthsyContainer">
          <div className="pt-3 ms-3 healthsyServices">
            {/* <Breadcrumbs
						breadcrumbText="Healthsy Service"
						breadcrumbLink="/add-new-doctors"
						nestedText="Order Medicines"
						nestedLink=""
						nestedText2="Masters"
						nestedLink2=""
						nestedText3={edit ? "Edit Marketers" : "Add Marketers"}
						nestedLink3=""
						className="healthsyMasterBreadCrumbs"
					/> */}
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
            <div className="row car-dep-form">
              <div className="col-5">
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="Marketer Name"
                  errorText="Please enter the Marketer Name"
                  name="marketers_name"
                  placeholder="Type here..."
                />
              </div>

              <div className="col-5">
                <InputRadioField
                  register={register}
                  errors={errors}
                  setValue={setValue}
                  watch={watch}
                  className="manufacturerRadioBtn"
                />
              </div>
            </div>
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </MainconternLayout>

      {/* </Home> */}
      {success && (
        <SucessModal
          page={"/healthsy-services/order-medicines/masters/marketers"}
          name="new manufacturer list"
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );
};

export default MarketersListForm;
